"use strict";
/*
 * Uniter Markdown Plugin - Adds support for an inline Markdown syntax to PHP
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/markdown-plugin/
 *
 * Released under the MIT license
 * https://github.com/uniter/markdown-plugin/raw/master/MIT-LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var PlainTextNode = /** @class */ (function () {
    function PlainTextNode(text) {
        this.text = text;
    }
    PlainTextNode.prototype.toHtml = function () {
        return this.text;
    };
    return PlainTextNode;
}());
exports.default = PlainTextNode;
var factory = function () {
    return PlainTextNode;
};
exports.factory = factory;
//# sourceMappingURL=PlainTextNode.js.map